import React, {FC} from "react"
import {UseBasket} from "@irati/checkout/utils/basket/useBasket"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton"
import {Row} from "@irati/ui/src/ColumnRow"
import {Body, H4} from "@irati/ui/src/Typography"
import {Hr} from "@irati/ui/src/Layout"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import styled from "styled-components"
import {Basket} from "@irati/types"
import {Checkbox} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import FormatMessage from "@irati/utils/lang/types/FormatMessage"
import {AddressInfo} from "./AddressInfo"

interface Props extends InjectIntl {
  load?: Promise<any>,
  onEditClick?: () => void,
  onPlaceOrderClick?: () => void,
  basket: UseBasket | Basket,
  termsAgreed: boolean,
  toggleTermsAgreed: () => void
}

const Link = styled.a`
  margin-left: ${({theme}) => theme.spacing.half};
`

const checkboxValidation = (formatMessage: FormatMessage) => (
  Validation.bool().oneOf([true], formatMessage({id: "platform.defaultValidation.required"}))
)

const AddressInfoSection: FC<Props> = ({
  basket,
  termsAgreed,
  toggleTermsAgreed,
  onEditClick,
  onPlaceOrderClick,
  load,
  formatMessage
}) => {
  const {shippingAddress} = basket as Required<UseBasket>

  return (
    <Flex direction="column" marginTop={3} marginBottom={4} width="100%">
      <Flex direction="row" justifyContent="space-between" marginBottom={2}>
        <H4 paddingLeft={2} marginBottom={2}>
          <FormattedMessage id="flexiRewards.merchandise.checkout.deliveryAddress" />
        </H4>
        <Button small onClick={onEditClick}>
          <FormattedMessage id="flexiRewards.merchandise.checkout.edit" />
        </Button>
      </Flex>
      <Row paddingLeft={2} marginBottom={2}>
        <AddressInfo showEmailConfirmation shippingAddress={shippingAddress} />
      </Row>
      <Hr />
      <Flex direction="column">
        <Checkbox
          name="termsAndConditionsCheckbox"
          onChange={toggleTermsAgreed}
          checked={termsAgreed}
          validation={checkboxValidation(formatMessage)}>
          <FormattedMessage id="flexiRewards.merchandise.checkout.terms3" />
        </Checkbox>
        <Flex justifyContent="center" direction="column" width="80%" margin="auto" paddingTop={2}>
          <Body textAlign="center" small marginBottom={1}>
            <FormattedMessage id="flexiRewards.merchandise.checkout.terms1" />
            <Link rel="noopener noreferrer" target="_blank" href={formatMessage({id: "flexiRewards.merchandise.checkout.saleTermsUrl"})}>
              <FormattedMessage id="flexiRewards.merchandise.checkout.terms2" />
            </Link>
          </Body>
          <ValidationButton primary onClick={onPlaceOrderClick} load={load}>
            <FormattedMessage id="flexiRewards.merchandise.checkout.placeOrder" />
          </ValidationButton>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default injectIntl(AddressInfoSection)
